module.exports = __webpack_public_path__ + "img/ufton_b4.1c69563c.jpg";